
import React from 'react';
import { Site } from '@/services/types';
import OrganizationSEOSchema from './seo/OrganizationSEOSchema';
import LocalBusinessSEOSchema from './seo/LocalBusinessSEOSchema';
import CollectionPageSEOSchema from './seo/CollectionPageSEOSchema';

interface SitesSEOProps {
  sites: Site[];
  isDeptPage?: boolean;
  deptName?: string;
  deptCode?: string;
}

const SitesSEO: React.FC<SitesSEOProps> = ({ 
  sites, 
  isDeptPage, 
  deptName, 
  deptCode 
}) => {
  return (
    <>
      <OrganizationSEOSchema sites={sites} />
      <LocalBusinessSEOSchema 
        sites={sites} 
        isDeptPage={isDeptPage}
        deptName={deptName}
      />
      <CollectionPageSEOSchema 
        sites={sites}
        isDeptPage={!!isDeptPage}
        deptName={deptName}
        deptCode={deptCode}
      />
    </>
  );
};

export default SitesSEO;
